<template>
  <div>
    <div id="claim-type-form">
      <div class="title-area">
        <common-text-medium text="損種（必要情報）" />
        <div class="action-button-area">
          <div @click="callDownloadAll" class="download-all-button">
            <feather-icon
              icon="DownloadIcon"
              class="icon-button mr-2"
              svgClasses="w-6 h-6"
            ></feather-icon>
            <span>一括ダウンロード</span>
          </div>
          <feather-icon
            v-if="isInsuranceCompany"
            icon="Trash2Icon"
            class="trash-icon-button ml-6"
            svgClasses="h-6 w-6"
            @click="openDeleteModal"
          />
        </div>
      </div>
      <hull-dropdown-select
        v-if="isInsuranceCompany"
        class="filter-input mt-4 mb-8"
        :selectOptions="claimTypeOptions"
        :onSelect="onSelectClaimType"
        :selectedValue="selectedClaimType"
        placeholder="損種"
        bordered
        :isSearchable="true"
      ></hull-dropdown-select>
      <div class="mt-4 mb-6" v-else>{{ claimTypeName }}</div>

      <div
        class="my-4"
        v-for="(step, index) in claimReportTypeSteps"
        :key="index"
      >
        <vs-divider class="my-0"></vs-divider>
        <common-text-medium class="mt-5" :text="step.name" />
        <div
          class="my-5"
          v-for="(claimReportTypeStepItem,
          index) in step.claim_report_type_step_items"
          :key="index"
        >
          <!-- 一行テキスト -->
          <form-one-line-text
            v-if="
              claimReportTypeStepItem.claim_report_item.claim_item.input_type ==
                1
            "
            :title="claimReportTypeStepItem.claim_report_item.claim_item.name"
            :inputValue="claimReportTypeStepItem.claim_report_item.input_values"
            :initialSwitchValue="claimReportTypeStepItem.mandatory"
            :createDate="
              Date.parse(claimReportTypeStepItem.claim_report_item.created_at)
            "
            :updateDate="
              Date.parse(claimReportTypeStepItem.claim_report_item.updated_at)
            "
            :onClickSave="
              inputValue =>
                callSaveForm(
                  claimReportTypeStepItem.claim_report_item.id,
                  inputValue,
                  claimReportTypeStepItem.claim_report_item.version
                )
            "
            :onSwitchChange="
              value =>
                callUpdateStepItem(
                  claimReportId,
                  claimReportTypeId,
                  step.id,
                  claimReportTypeStepItem.id,
                  value,
                  claimReportTypeStepItem.status,
                  claimReportTypeStepItem.version
                )
            "
            :onClickHelp="
              () =>
                openDescriptionModal(
                  claimReportTypeStepItem.claim_report_item.claim_item
                    .description_owner,
                  claimReportTypeStepItem.claim_report_item.claim_item
                    .description_insurer
                )
            "
            :isAdmin="isInsuranceCompany"
            :mandatory="claimReportTypeStepItem.mandatory"
            :onStatusChange="
              status =>
                callUpdateStepItem(
                  claimReportId,
                  claimReportTypeId,
                  step.id,
                  claimReportTypeStepItem.id,
                  claimReportTypeStepItem.mandatory,
                  status.value,
                  claimReportTypeStepItem.version
                )
            "
            :statusOptions="stepItemStatusOptions"
            :initialStatusValue="
              getStatusFromValue(claimReportTypeStepItem.status)
            "
            :key="claimReportTypeStepItem.version + 'oneline'"
          ></form-one-line-text>

          <!-- 段落テキスト -->
          <form-multi-line-text
            v-else-if="
              claimReportTypeStepItem.claim_report_item.claim_item.input_type ==
                2
            "
            :title="claimReportTypeStepItem.claim_report_item.claim_item.name"
            :inputValue="claimReportTypeStepItem.claim_report_item.input_values"
            :initialSwitchValue="claimReportTypeStepItem.mandatory"
            :createDate="
              Date.parse(claimReportTypeStepItem.claim_report_item.created_at)
            "
            :updateDate="
              Date.parse(claimReportTypeStepItem.claim_report_item.updated_at)
            "
            :onClickSave="
              inputValue =>
                callSaveForm(
                  claimReportTypeStepItem.claim_report_item.id,
                  inputValue,
                  claimReportTypeStepItem.claim_report_item.version
                )
            "
            :onSwitchChange="
              value =>
                callUpdateStepItem(
                  claimReportId,
                  claimReportTypeId,
                  step.id,
                  claimReportTypeStepItem.id,
                  value,
                  claimReportTypeStepItem.status,
                  claimReportTypeStepItem.version
                )
            "
            :onClickHelp="
              () =>
                openDescriptionModal(
                  claimReportTypeStepItem.claim_report_item.claim_item
                    .description_owner,
                  claimReportTypeStepItem.claim_report_item.claim_item
                    .description_insurer
                )
            "
            :isAdmin="isInsuranceCompany"
            :mandatory="claimReportTypeStepItem.mandatory"
            :onStatusChange="
              status =>
                callUpdateStepItem(
                  claimReportId,
                  claimReportTypeId,
                  step.id,
                  claimReportTypeStepItem.id,
                  claimReportTypeStepItem.mandatory,
                  status.value,
                  claimReportTypeStepItem.version
                )
            "
            :statusOptions="stepItemStatusOptions"
            :initialStatusValue="
              getStatusFromValue(claimReportTypeStepItem.status)
            "
            :key="claimReportTypeStepItem.version + 'multiline'"
          ></form-multi-line-text>
          <!-- ファイル添付 -->
          <form-file-manager
            v-if="
              claimReportTypeStepItem.claim_report_item.claim_item.input_type ==
                3
            "
            :title="claimReportTypeStepItem.claim_report_item.claim_item.name"
            :inputValue="claimReportTypeStepItem.claim_report_item.input_values"
            :initialSwitchValue="claimReportTypeStepItem.mandatory"
            :createDate="
              Date.parse(claimReportTypeStepItem.claim_report_item.created_at)
            "
            :updateDate="
              Date.parse(claimReportTypeStepItem.claim_report_item.updated_at)
            "
            :onClickSave="
              fileList =>
                callSaveFile(
                  claimReportId,
                  claimReportTypeStepItem.claim_report_item.id,
                  fileList
                )
            "
            :onClickDelete="
              fileName =>
                callDeleteFile(
                  claimReportId,
                  claimReportTypeStepItem.claim_report_item.id,
                  fileName
                )
            "
            :onSwitchChange="
              value =>
                callUpdateStepItem(
                  claimReportId,
                  claimReportTypeId,
                  step.id,
                  claimReportTypeStepItem.id,
                  value,
                  claimReportTypeStepItem.status,
                  claimReportTypeStepItem.version
                )
            "
            :onClickHelp="
              () =>
                openDescriptionModal(
                  claimReportTypeStepItem.claim_report_item.claim_item
                    .description_owner,
                  claimReportTypeStepItem.claim_report_item.claim_item
                    .description_insurer
                )
            "
            :uploadFile="
              file =>
                uploadFile(claimReportTypeStepItem.claim_report_item.id, file)
            "
            :isAdmin="isInsuranceCompany"
            :mandatory="claimReportTypeStepItem.mandatory"
            :onStatusChange="
              status =>
                callUpdateStepItem(
                  claimReportId,
                  claimReportTypeId,
                  step.id,
                  claimReportTypeStepItem.id,
                  claimReportTypeStepItem.mandatory,
                  status.value,
                  claimReportTypeStepItem.version
                )
            "
            :statusOptions="stepItemStatusOptions"
            :initialStatusValue="
              getStatusFromValue(claimReportTypeStepItem.status)
            "
            :onClickDownloadFile="
              (fileName, token) =>
                downloadFile(
                  insurerEnterpriseId,
                  ownerEnterpriseId,
                  claimReportId,
                  claimReportTypeStepItem.claim_report_item.id,
                  fileName,
                  token,
                  false
                )
            "
            :onClickFileLink="
              (fileName, token) =>
                downloadFile(
                  insurerEnterpriseId,
                  ownerEnterpriseId,
                  claimReportId,
                  claimReportTypeStepItem.claim_report_item.id,
                  fileName,
                  token,
                  true
                )
            "
            :key="claimReportTypeStepItem.version + 'file'"
          >
          </form-file-manager>
          <!-- チェックボックス -->
          <form-check-box
            v-else-if="
              claimReportTypeStepItem.claim_report_item.claim_item.input_type ==
                4
            "
            :title="claimReportTypeStepItem.claim_report_item.claim_item.name"
            :inputValue="claimReportTypeStepItem.claim_report_item.input_values"
            :initialSwitchValue="claimReportTypeStepItem.mandatory"
            :createDate="
              Date.parse(claimReportTypeStepItem.claim_report_item.created_at)
            "
            :updateDate="
              Date.parse(claimReportTypeStepItem.claim_report_item.updated_at)
            "
            :onClickSave="
              inputValue =>
                callSaveForm(
                  claimReportTypeStepItem.claim_report_item.id,
                  inputValue,
                  claimReportTypeStepItem.claim_report_item.version
                )
            "
            :onSwitchChange="
              value =>
                callUpdateStepItem(
                  claimReportId,
                  claimReportTypeId,
                  step.id,
                  claimReportTypeStepItem.id,
                  value,
                  claimReportTypeStepItem.status,
                  claimReportTypeStepItem.version
                )
            "
            :onClickHelp="
              () =>
                openDescriptionModal(
                  claimReportTypeStepItem.claim_report_item.claim_item
                    .description_owner,
                  claimReportTypeStepItem.claim_report_item.claim_item
                    .description_insurer
                )
            "
            :options="
              claimReportTypeStepItem.claim_report_item.claim_item.choices
            "
            :isAdmin="isInsuranceCompany"
            :mandatory="claimReportTypeStepItem.mandatory"
            :onStatusChange="
              status =>
                callUpdateStepItem(
                  claimReportId,
                  claimReportTypeId,
                  step.id,
                  claimReportTypeStepItem.id,
                  claimReportTypeStepItem.mandatory,
                  status.value,
                  claimReportTypeStepItem.version
                )
            "
            :statusOptions="stepItemStatusOptions"
            :initialStatusValue="
              getStatusFromValue(claimReportTypeStepItem.status)
            "
            :key="claimReportTypeStepItem.version + 'check'"
          ></form-check-box>
          <!-- プルダウン -->
          <form-dropdown-select
            v-else-if="
              claimReportTypeStepItem.claim_report_item.claim_item.input_type ==
                5
            "
            :title="claimReportTypeStepItem.claim_report_item.claim_item.name"
            :inputValue="claimReportTypeStepItem.claim_report_item.input_values"
            :initialSwitchValue="claimReportTypeStepItem.mandatory"
            :createDate="
              Date.parse(claimReportTypeStepItem.claim_report_item.created_at)
            "
            :updateDate="
              Date.parse(claimReportTypeStepItem.claim_report_item.updated_at)
            "
            :onClickSave="
              inputValue =>
                callSaveForm(
                  claimReportTypeStepItem.claim_report_item.id,
                  inputValue,
                  claimReportTypeStepItem.claim_report_item.version
                )
            "
            :onSwitchChange="
              value =>
                callUpdateStepItem(
                  claimReportId,
                  claimReportTypeId,
                  step.id,
                  claimReportTypeStepItem.id,
                  value,
                  claimReportTypeStepItem.status,
                  claimReportTypeStepItem.version
                )
            "
            :onClickHelp="
              () =>
                openDescriptionModal(
                  claimReportTypeStepItem.claim_report_item.claim_item
                    .description_owner,
                  claimReportTypeStepItem.claim_report_item.claim_item
                    .description_insurer
                )
            "
            :options="
              claimReportTypeStepItem.claim_report_item.claim_item.choices
            "
            :isAdmin="isInsuranceCompany"
            :mandatory="claimReportTypeStepItem.mandatory"
            :onStatusChange="
              status =>
                callUpdateStepItem(
                  claimReportId,
                  claimReportTypeId,
                  step.id,
                  claimReportTypeStepItem.id,
                  claimReportTypeStepItem.mandatory,
                  status.value,
                  claimReportTypeStepItem.version
                )
            "
            :statusOptions="stepItemStatusOptions"
            :initialStatusValue="
              getStatusFromValue(claimReportTypeStepItem.status)
            "
            :key="claimReportTypeStepItem.version + 'dropdown'"
          ></form-dropdown-select>
          <!-- ラジオボタン -->
          <form-radio-button
            v-else-if="
              claimReportTypeStepItem.claim_report_item.claim_item.input_type ==
                6
            "
            :title="claimReportTypeStepItem.claim_report_item.claim_item.name"
            :inputValue="claimReportTypeStepItem.claim_report_item.input_values"
            :initialSwitchValue="claimReportTypeStepItem.mandatory"
            :createDate="
              Date.parse(claimReportTypeStepItem.claim_report_item.created_at)
            "
            :updateDate="
              Date.parse(claimReportTypeStepItem.claim_report_item.updated_at)
            "
            :onClickSave="
              inputValue =>
                callSaveForm(
                  claimReportTypeStepItem.claim_report_item.id,
                  inputValue,
                  claimReportTypeStepItem.claim_report_item.version
                )
            "
            :onSwitchChange="
              value =>
                callUpdateStepItem(
                  claimReportId,
                  claimReportTypeId,
                  step.id,
                  claimReportTypeStepItem.id,
                  value,
                  claimReportTypeStepItem.status,
                  claimReportTypeStepItem.version
                )
            "
            :onClickHelp="
              () =>
                openDescriptionModal(
                  claimReportTypeStepItem.claim_report_item.claim_item
                    .description_owner,
                  claimReportTypeStepItem.claim_report_item.claim_item
                    .description_insurer
                )
            "
            :options="
              claimReportTypeStepItem.claim_report_item.claim_item.choices
            "
            :isAdmin="isInsuranceCompany"
            :mandatory="claimReportTypeStepItem.mandatory"
            :onStatusChange="
              status =>
                callUpdateStepItem(
                  claimReportId,
                  claimReportTypeId,
                  step.id,
                  claimReportTypeStepItem.id,
                  claimReportTypeStepItem.mandatory,
                  status.value,
                  claimReportTypeStepItem.version
                )
            "
            :statusOptions="stepItemStatusOptions"
            :initialStatusValue="
              getStatusFromValue(claimReportTypeStepItem.status)
            "
            :key="claimReportTypeStepItem.version + 'radio'"
          ></form-radio-button>
          <!-- 連絡先 -->
          <form-contact
            v-if="
              claimReportTypeStepItem.claim_report_item.claim_item.input_type ==
                7
            "
            :title="claimReportTypeStepItem.claim_report_item.claim_item.name"
            :inputValue="claimReportTypeStepItem.claim_report_item.input_values"
            :initialSwitchValue="claimReportTypeStepItem.mandatory"
            :createdDate="
              Date.parse(claimReportTypeStepItem.claim_report_item.created_at)
            "
            :createDate="
              Date.parse(claimReportTypeStepItem.claim_report_item.created_at)
            "
            :updateDate="
              Date.parse(claimReportTypeStepItem.claim_report_item.updated_at)
            "
            :onClickSave="
              inputValue =>
                callSaveForm(
                  claimReportTypeStepItem.claim_report_item.id,
                  inputValue,
                  claimReportTypeStepItem.claim_report_item.version
                )
            "
            :onSwitchChange="
              value =>
                callUpdateStepItem(
                  claimReportId,
                  claimReportTypeId,
                  step.id,
                  claimReportTypeStepItem.id,
                  value,
                  claimReportTypeStepItem.status,
                  claimReportTypeStepItem.version
                )
            "
            :onClickHelp="
              () =>
                openDescriptionModal(
                  claimReportTypeStepItem.claim_report_item.claim_item
                    .description_owner,
                  claimReportTypeStepItem.claim_report_item.claim_item
                    .description_insurer
                )
            "
            :isAdmin="isInsuranceCompany"
            :mandatory="claimReportTypeStepItem.mandatory"
            :onStatusChange="
              status =>
                callUpdateStepItem(
                  claimReportId,
                  claimReportTypeId,
                  step.id,
                  claimReportTypeStepItem.id,
                  claimReportTypeStepItem.mandatory,
                  status.value,
                  claimReportTypeStepItem.version
                )
            "
            :statusOptions="stepItemStatusOptions"
            :initialStatusValue="
              getStatusFromValue(claimReportTypeStepItem.status)
            "
            :key="claimReportTypeStepItem.version + 'contact'"
          ></form-contact>
          <!-- リンク -->
          <form-link
            v-else-if="
              claimReportTypeStepItem.claim_report_item.claim_item.input_type ==
                8
            "
            :title="claimReportTypeStepItem.claim_report_item.claim_item.name"
            :inputValue="claimReportTypeStepItem.claim_report_item.input_values"
            :initialSwitchValue="claimReportTypeStepItem.mandatory"
            :createDate="
              Date.parse(claimReportTypeStepItem.claim_report_item.created_at)
            "
            :updateDate="
              Date.parse(claimReportTypeStepItem.claim_report_item.updated_at)
            "
            :onClickSave="
              inputValue =>
                callSaveForm(
                  claimReportTypeStepItem.claim_report_item.id,
                  inputValue,
                  claimReportTypeStepItem.claim_report_item.version
                )
            "
            :onSwitchChange="
              value =>
                callUpdateStepItem(
                  claimReportId,
                  claimReportTypeId,
                  step.id,
                  claimReportTypeStepItem.id,
                  value,
                  claimReportTypeStepItem.status,
                  claimReportTypeStepItem.version
                )
            "
            :onClickHelp="
              () =>
                openDescriptionModal(
                  claimReportTypeStepItem.claim_report_item.claim_item
                    .description_owner,
                  claimReportTypeStepItem.claim_report_item.claim_item
                    .description_insurer
                )
            "
            :isAdmin="isInsuranceCompany"
            :mandatory="claimReportTypeStepItem.mandatory"
            :onStatusChange="
              status =>
                callUpdateStepItem(
                  claimReportId,
                  claimReportTypeId,
                  step.id,
                  claimReportTypeStepItem.id,
                  claimReportTypeStepItem.mandatory,
                  status.value,
                  claimReportTypeStepItem.version
                )
            "
            :statusOptions="stepItemStatusOptions"
            :initialStatusValue="
              getStatusFromValue(claimReportTypeStepItem.status)
            "
            :key="claimReportTypeStepItem.version + 'link'"
          ></form-link>
          <!-- 日付 -->
          <form-date
            v-else-if="
              claimReportTypeStepItem.claim_report_item.claim_item.input_type ==
                9
            "
            :title="claimReportTypeStepItem.claim_report_item.claim_item.name"
            :inputValue="claimReportTypeStepItem.claim_report_item.input_values"
            :initialSwitchValue="claimReportTypeStepItem.mandatory"
            :createDate="
              Date.parse(claimReportTypeStepItem.claim_report_item.created_at)
            "
            :updateDate="
              Date.parse(claimReportTypeStepItem.claim_report_item.updated_at)
            "
            :onClickSave="
              inputValue =>
                callSaveForm(
                  claimReportTypeStepItem.claim_report_item.id,
                  inputValue,
                  claimReportTypeStepItem.claim_report_item.version
                )
            "
            :onSwitchChange="
              value =>
                callUpdateStepItem(
                  claimReportId,
                  claimReportTypeId,
                  step.id,
                  claimReportTypeStepItem.id,
                  value,
                  claimReportTypeStepItem.status,
                  claimReportTypeStepItem.version
                )
            "
            :onClickHelp="
              () =>
                openDescriptionModal(
                  claimReportTypeStepItem.claim_report_item.claim_item
                    .description_owner,
                  claimReportTypeStepItem.claim_report_item.claim_item
                    .description_insurer
                )
            "
            :isAdmin="isInsuranceCompany"
            :mandatory="claimReportTypeStepItem.mandatory"
            :onStatusChange="
              status =>
                callUpdateStepItem(
                  claimReportId,
                  claimReportTypeId,
                  step.id,
                  claimReportTypeStepItem.id,
                  claimReportTypeStepItem.mandatory,
                  status.value,
                  claimReportTypeStepItem.version
                )
            "
            :statusOptions="stepItemStatusOptions"
            :initialStatusValue="
              getStatusFromValue(claimReportTypeStepItem.status)
            "
            :key="claimReportTypeStepItem.version + 'date'"
          ></form-date>
          <!-- 時間 -->
          <form-time
            v-else-if="
              claimReportTypeStepItem.claim_report_item.claim_item.input_type ==
                10
            "
            :title="claimReportTypeStepItem.claim_report_item.claim_item.name"
            :inputValue="claimReportTypeStepItem.claim_report_item.input_values"
            :initialSwitchValue="claimReportTypeStepItem.mandatory"
            :createDate="
              Date.parse(claimReportTypeStepItem.claim_report_item.created_at)
            "
            :updateDate="
              Date.parse(claimReportTypeStepItem.claim_report_item.updated_at)
            "
            :onClickSave="
              inputValue =>
                callSaveForm(
                  claimReportTypeStepItem.claim_report_item.id,
                  inputValue,
                  claimReportTypeStepItem.claim_report_item.version
                )
            "
            :onSwitchChange="
              value =>
                callUpdateStepItem(
                  claimReportId,
                  claimReportTypeId,
                  step.id,
                  claimReportTypeStepItem.id,
                  value,
                  claimReportTypeStepItem.status,
                  claimReportTypeStepItem.version
                )
            "
            :onClickHelp="
              () =>
                openDescriptionModal(
                  claimReportTypeStepItem.claim_report_item.claim_item
                    .description_owner,
                  claimReportTypeStepItem.claim_report_item.claim_item
                    .description_insurer
                )
            "
            :isAdmin="isInsuranceCompany"
            :mandatory="claimReportTypeStepItem.mandatory"
            :onStatusChange="
              status =>
                callUpdateStepItem(
                  claimReportId,
                  claimReportTypeId,
                  step.id,
                  claimReportTypeStepItem.id,
                  claimReportTypeStepItem.mandatory,
                  status.value,
                  claimReportTypeStepItem.version
                )
            "
            :statusOptions="stepItemStatusOptions"
            :initialStatusValue="
              getStatusFromValue(claimReportTypeStepItem.status)
            "
            :key="claimReportTypeStepItem.version + 'time'"
          ></form-time>
          <!-- 位置情報 -->
          <form-coordinates
            v-else-if="
              claimReportTypeStepItem.claim_report_item.claim_item.input_type ==
                11
            "
            :title="claimReportTypeStepItem.claim_report_item.claim_item.name"
            :inputValue="claimReportTypeStepItem.claim_report_item.input_values"
            :initialSwitchValue="claimReportTypeStepItem.mandatory"
            :createDate="
              Date.parse(claimReportTypeStepItem.claim_report_item.created_at)
            "
            :updateDate="
              Date.parse(claimReportTypeStepItem.claim_report_item.updated_at)
            "
            :onClickSave="
              inputValue =>
                callSaveForm(
                  claimReportTypeStepItem.claim_report_item.id,
                  inputValue,
                  claimReportTypeStepItem.claim_report_item.version
                )
            "
            :onSwitchChange="
              value =>
                callUpdateStepItem(
                  claimReportId,
                  claimReportTypeId,
                  step.id,
                  claimReportTypeStepItem.id,
                  value,
                  claimReportTypeStepItem.status,
                  claimReportTypeStepItem.version
                )
            "
            :onClickHelp="
              () =>
                openDescriptionModal(
                  claimReportTypeStepItem.claim_report_item.claim_item
                    .description_owner,
                  claimReportTypeStepItem.claim_report_item.claim_item
                    .description_insurer
                )
            "
            :isAdmin="isInsuranceCompany"
            :mandatory="claimReportTypeStepItem.mandatory"
            :onStatusChange="
              status =>
                callUpdateStepItem(
                  claimReportId,
                  claimReportTypeId,
                  step.id,
                  claimReportTypeStepItem.id,
                  claimReportTypeStepItem.mandatory,
                  status.value,
                  claimReportTypeStepItem.version
                )
            "
            :statusOptions="stepItemStatusOptions"
            :initialStatusValue="
              getStatusFromValue(claimReportTypeStepItem.status)
            "
            :key="claimReportTypeStepItem.version + 'coordinates'"
          ></form-coordinates>
          <!-- 金額 -->
          <form-price
            v-else-if="
              claimReportTypeStepItem.claim_report_item.claim_item.input_type ==
                12
            "
            :title="claimReportTypeStepItem.claim_report_item.claim_item.name"
            :inputValue="claimReportTypeStepItem.claim_report_item.input_values"
            :initialSwitchValue="claimReportTypeStepItem.mandatory"
            :createDate="
              Date.parse(claimReportTypeStepItem.claim_report_item.created_at)
            "
            :updateDate="
              Date.parse(claimReportTypeStepItem.claim_report_item.updated_at)
            "
            :onClickSave="
              inputValue =>
                callSaveForm(
                  claimReportTypeStepItem.claim_report_item.id,
                  inputValue,
                  claimReportTypeStepItem.claim_report_item.version
                )
            "
            :onSwitchChange="
              value =>
                callUpdateStepItem(
                  claimReportId,
                  claimReportTypeId,
                  step.id,
                  claimReportTypeStepItem.id,
                  value,
                  claimReportTypeStepItem.status,
                  claimReportTypeStepItem.version
                )
            "
            :onClickHelp="
              () =>
                openDescriptionModal(
                  claimReportTypeStepItem.claim_report_item.claim_item
                    .description_owner,
                  claimReportTypeStepItem.claim_report_item.claim_item
                    .description_insurer
                )
            "
            selectPlaceholder="円"
            textPlaceholder="金額"
            :isAdmin="isInsuranceCompany"
            :mandatory="claimReportTypeStepItem.mandatory"
            :onStatusChange="
              status =>
                callUpdateStepItem(
                  claimReportId,
                  claimReportTypeId,
                  step.id,
                  claimReportTypeStepItem.id,
                  claimReportTypeStepItem.mandatory,
                  status.value,
                  claimReportTypeStepItem.version
                )
            "
            :statusOptions="stepItemStatusOptions"
            :initialStatusValue="
              getStatusFromValue(claimReportTypeStepItem.status)
            "
            :key="claimReportTypeStepItem.version + 'price'"
          ></form-price>
          <!-- 単位 -->
          <form-unit
            v-else-if="
              claimReportTypeStepItem.claim_report_item.claim_item.input_type ==
                13
            "
            :title="claimReportTypeStepItem.claim_report_item.claim_item.name"
            :inputValue="claimReportTypeStepItem.claim_report_item.input_values"
            :initialSwitchValue="claimReportTypeStepItem.mandatory"
            :createDate="
              Date.parse(claimReportTypeStepItem.claim_report_item.created_at)
            "
            :updateDate="
              Date.parse(claimReportTypeStepItem.claim_report_item.updated_at)
            "
            :onClickSave="
              inputValue =>
                callSaveForm(
                  claimReportTypeStepItem.claim_report_item.id,
                  inputValue,
                  claimReportTypeStepItem.claim_report_item.version
                )
            "
            :onSwitchChange="
              value =>
                callUpdateStepItem(
                  claimReportId,
                  claimReportTypeId,
                  step.id,
                  claimReportTypeStepItem.id,
                  value,
                  claimReportTypeStepItem.status,
                  claimReportTypeStepItem.version
                )
            "
            :onClickHelp="
              () =>
                openDescriptionModal(
                  claimReportTypeStepItem.claim_report_item.claim_item
                    .description_owner,
                  claimReportTypeStepItem.claim_report_item.claim_item
                    .description_insurer
                )
            "
            selectPlaceholder="GT"
            textPlaceholder="数値"
            :isAdmin="isInsuranceCompany"
            :mandatory="claimReportTypeStepItem.mandatory"
            :onStatusChange="
              status =>
                callUpdateStepItem(
                  claimReportId,
                  claimReportTypeId,
                  step.id,
                  claimReportTypeStepItem.id,
                  claimReportTypeStepItem.mandatory,
                  status.value,
                  claimReportTypeStepItem.version
                )
            "
            :statusOptions="stepItemStatusOptions"
            :initialStatusValue="
              getStatusFromValue(claimReportTypeStepItem.status)
            "
            :key="claimReportTypeStepItem.version + 'unit'"
          ></form-unit>
        </div>
      </div>
    </div>
    <common-modal title="" ref="DeleteModal">
      <template v-slot:contents>
        <div class="delete-container">
          {{
            claimTypeName
          }}を削除した場合、保存されていた情報は復元できません。本当に削除しますか？
          <div class="button-area">
            <common-button
              class="button"
              title="キャンセル"
              :click="closeDeleteModal"
              color="#BDBDBD"
              text-color="#757575"
              type="border"
            ></common-button>
            <common-button
              class="button"
              title="削除"
              :click="() => callDeleteReportClaimType()"
            ></common-button>
          </div>
        </div>
      </template>
    </common-modal>
    <common-modal title="" ref="DescriptionModal">
      <template v-slot:contents>
        <div class="description-container">
          <template v-if="isInsuranceCompany">
            <div class="description-title">管理者専用説明</div>
            <div class="description-content">
              {{ displayDescriptionOwner }}
            </div>
          </template>

          <div class="description-title mt-8">保険契約者向け説明</div>
          <div class="description-content">
            {{ displayDescriptionInsurer }}
          </div>
        </div>
      </template>
    </common-modal>
    <common-modal title="" ref="ChangeClaimTypeModal">
      <template v-slot:contents>
        <div class="change-claim-type-container">
          損害種類を変更すると、ステップおよび必要情報の項目が変更されます。<br />変更前に登録された必要情報は変更後も引き継がれます。
          <div class="button-area">
            <common-button
              class="button"
              title="キャンセル"
              :click="closeChangeClaimTypeModal"
              color="#BDBDBD"
              text-color="#757575"
              type="border"
            ></common-button>
            <common-button
              class="button"
              title="変更"
              :click="() => callUpdateReportClaimType()"
            ></common-button>
          </div>
        </div>
      </template>
    </common-modal>
  </div>
</template>

<script>
import { ColorMixin, HullInsranceMixin } from "@/mixins";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";

import CommonTextMedium from "../../components/atoms/CommonTextMedium.vue";
import CommonButton from "../../components/molecules/CommonButton.vue";
import CommonModal from "../../components/organisms/CommonModal.vue";
import FormOneLineText from "../../components/organisms/FormOneLineText.vue";
import FormMultiLineText from "../../components/organisms/FormMultiLineText.vue";
import FormFileManager from "../../components/organisms/FormFileManager.vue";
import FormCheckBox from "../../components/organisms/FormCheckBox.vue";
import FormDropdownSelect from "../../components/organisms/FormDropdownSelect.vue";
import FormRadioButton from "../../components/organisms/FormRadioButton.vue";
import FormContact from "../../components/organisms/FormContact.vue";
import FormLink from "../../components/organisms/FormLink.vue";
import FormPrice from "../../components/organisms/FormPrice.vue";
import FormUnit from "../../components/organisms/FormUnit.vue";
import FormCoordinates from "../../components/organisms/FormCoordinates.vue";
import FormTime from "../../components/organisms/FormTime.vue";
import FormDate from "../../components/organisms/FormDate.vue";

import HullDropdownSelect from "../../components/molecules/HullDropdownSelect.vue";

import { FileUtil, DownloadUtil } from "@/utils";
import { storagePrefixUrl } from "@/firebase/firebaseConfig";
import { HULL_INSURANCE_STEP_ITEM_STATUS } from "@/config/const";

const claimReportClaimTypeRepository = AiseaApiFactory.get(
  "hullInsuranceEnterpriseReportClaimType"
);

export default {
  name: "O.ClaimTypeForm",
  components: {
    CommonTextMedium,
    CommonButton,
    CommonModal,
    FormOneLineText,
    FormMultiLineText,
    FormFileManager,
    FormCheckBox,
    FormDropdownSelect,
    FormRadioButton,
    FormContact,
    FormLink,
    FormPrice,
    FormUnit,
    FormCoordinates,
    FormTime,
    FormDate,
    HullDropdownSelect,
  },
  mixins: [ColorMixin, HullInsranceMixin],
  props: {
    preview: {
      type: Boolean,
      required: true,
    },
    claimReportId: {
      type: String,
      required: true,
    },
    claimReportTypeId: {
      type: String,
      required: true,
    },
    refreshData: {
      type: Function,
    },
    claimTypeOptions: {
      type: Array,
    },
    enterpriseKind: {
      type: Number,
    },
    insurerEnterpriseId: {
      type: String,
    },
    ownerEnterpriseId: {
      type: String,
    },
    mandatoryItemFilledData: {
      type: Array,
    },
  },
  data() {
    return {
      claimTypeName: "",
      claimReportTypeSteps: [],
      selectedClaimType: null,
      selectedClaimTypeTemp: null,
      dataURI: null,

      // DescriptionModal
      displayDescriptionOwner: "",
      displayDescriptionInsurer: "",
    };
  },
  computed: {
    isVesselOwner() {
      return this.enterpriseKind == 1;
    },
    isInsuranceCompany() {
      return this.enterpriseKind == 2;
    },
    stepItemStatusOptions() {
      return HULL_INSURANCE_STEP_ITEM_STATUS.map(element => {
        return {
          label: element.label,
          value: element.id,
          color: element.color,
        };
      });
    },
  },
  methods: {
    getStatusFromValue(value) {
      return this.stepItemStatusOptions.find(element => element.value == value);
    },
    setMandatoryItemFilledData(claimReportTypeSteps) {
      const data = claimReportTypeSteps.map(step => {
        return {
          name: step.name,
          maxNumber: step.claim_report_type_step_items.filter(
            stepItem => stepItem.mandatory
          ).length,
          number: step.claim_report_type_step_items.filter(
            stepItem => stepItem.mandatory && stepItem.status == 2
          ).length,
        };
      });
      this.$emit("update:mandatoryItemFilledData", data);
    },
    onSelectClaimType(value) {
      this.selectedClaimTypeTemp = value;
      this.openChangeClaimTypeModal();
    },
    async callUpdateStepItem(
      claimReportId,
      claimReportTypeId,
      claimReportTypeStepId,
      claimReportTypeStepItemId,
      mandatory,
      status,
      version
    ) {
      const res = await claimReportClaimTypeRepository.updateClaimReportTypeStepItem(
        claimReportId,
        claimReportTypeId,
        claimReportTypeStepId,
        claimReportTypeStepItemId,
        { mandatory: mandatory, status: status, version: version }
      );
      if (res.status == true) {
        await this.callFetch();
      } else {
        this.$vs.notify({
          title: "必要情報の更新に失敗しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
    },
    async callSaveForm(claimReportItemId, inputValue, version) {
      this.$vs.loading();
      const res = await claimReportClaimTypeRepository.updateClaimReportItem(
        this.claimReportId,
        claimReportItemId,
        {
          input_values: inputValue,
          version: version,
        }
      );
      if (res.status == true) {
        await this.callFetch();
      } else {
        this.$vs.notify({
          title: "必要情報の更新に失敗しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }

      this.$vs.loading.close();
    },
    async callFetch() {
      this.$vs.loading();
      const res = await claimReportClaimTypeRepository.fetchDetail(
        this.claimReportId,
        this.claimReportTypeId
      );
      if (res.status == true) {
        this.claimReportTypeSteps = res.data.claim_report_type_steps;
        this.setMandatoryItemFilledData(this.claimReportTypeSteps);
        this.claimTypeName = res.data.name;

        this.selectedClaimType = res.data.claim_type_id;
      } else {
        this.$vs.notify({
          title: "事故ページ損種の取得に失敗しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }

      this.$vs.loading.close();
    },
    async callDeleteReportClaimType() {
      this.$vs.loading();
      const res = await claimReportClaimTypeRepository.delete(
        this.claimReportId,
        this.claimReportTypeId
      );

      if (res.status == true) {
        this.refreshData();
        this.$vs.notify({
          title: "損種を削除しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      } else {
        this.$vs.notify({
          title: "損種の削除に失敗しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
      this.$vs.loading.close();
      this.closeDeleteModal();
    },
    async callUpdateReportClaimType() {
      this.$vs.loading();
      const res = await claimReportClaimTypeRepository.updateClaimReportClaimType(
        this.claimReportId,
        this.claimReportTypeId,
        this.selectedClaimTypeTemp
      );

      if (res.status == true) {
        this.refreshData();
        this.$vs.notify({
          title: "損種を変更しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      } else {
        this.$vs.notify({
          title: "損種の変更に失敗しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
      this.$vs.loading.close();
    },
    async callDownloadAll() {
      this.$vs.loading();
      const res = await claimReportClaimTypeRepository.downloadAll(
        this.claimReportId,
        this.claimReportTypeId
      );

      if (res.status == true) {
        const blob = new Blob([res.data]);
        const uri = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.download = `${this.claimTypeName}.zip`;
        link.href = uri;
        link.click();
      } else {
        this.$vs.notify({
          title: "損種ファイルのダウンロードに失敗しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }

      this.$vs.loading.close();
    },
    async fileUpload(claimReportId, claimReportItemId, file) {
      const formData = new FormData();
      const fileBlob = FileUtil.toBlob(file.src, file.type);
      formData.append("file", fileBlob, file.name);
      const res = await claimReportClaimTypeRepository.uploadFile(
        claimReportId,
        claimReportItemId,
        formData
      );
      return res.status;
    },
    async callSaveFile(claimReportId, claimReportItemId, fileList) {
      this.$vs.loading();
      await this.recursivelyUploadFiles(claimReportItemId, fileList, 0);
      this.$vs.loading.close();
      this.$vs.notify({
        title: "アップロード完了",
        color: "success",
        text: `ファイルのアップロードが完了しました。`,
      });
      await this.callFetch();
    },
    async callDeleteFile(claimReportId, claimReportItemId, fileName) {
      const res = await claimReportClaimTypeRepository.deleteFile(
        claimReportId,
        claimReportItemId,
        fileName
      );
      if (res.status == true) {
        this.callFetch();
        this.$vs.notify({
          title: "添付ファイルを削除しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      } else {
        this.$vs.notify({
          title: "添付ファイルの削除に失敗しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
    },
    async uploadFile(claimReportItemId, file) {
      let formData = new FormData();
      const fileBlob = FileUtil.toBlob(file.src, file.type);
      formData.append("file", fileBlob, file.name);

      const res = await claimReportClaimTypeRepository.uploadFile(
        this.claimReportId,
        claimReportItemId,
        formData
      );

      if (!res || !res.status) {
        this.$vs.notify({
          title: `${file.name}のアップロードに失敗しました。`,
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
    },
    async recursivelyUploadFiles(claimReportItemId, files, index) {
      if (!files || files.length === 0) return;
      if (files.length === index) return;

      await this.uploadFile(claimReportItemId, files[index]);
      await this.recursivelyUploadFiles(claimReportItemId, files, index + 1);
    },
    async deleteFile(payload) {
      const overviewId = payload.id;
      const filename = payload.name;

      try {
        this.$vs.loading();
        const res = await claimReportClaimTypeRepository.deleteSummaryFile(
          this.$route.params.id,
          overviewId,
          { file_name: filename }
        );
        if (!res || !res.status) {
          throw res.data;
        }

        await this.getReportOverviews();
        this.$vs.loading.close();
        this.$vs.notify({
          title: "削除完了",
          color: "success",
          text: `${filename}の削除が完了しました。`,
        });
      } catch (error) {
        this.$vs.loading.close();
        console.error(error);
        this.$vs.notify({
          title: `${filename}の削除に失敗しました。`,
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
    },
    async downloadFile(
      insurerEnterpriseId,
      ownerEnterpriseId,
      claimReportId,
      claimReportItemId,
      fileName,
      token,
      isOpenNewTab
    ) {
      const prefix = storagePrefixUrl;
      const filePath = encodeURIComponent(
        `e:${insurerEnterpriseId}/hull_insurance/enterprises:${ownerEnterpriseId}/reports:${claimReportId}/items:${claimReportItemId}/${fileName}`
      );
      try {
        const urlAndToken = `${prefix}${filePath}?alt=media&token=${token}`;
        if (isOpenNewTab) {
          window.open(urlAndToken);
        } else {
          const blob = await (await fetch(urlAndToken)).blob();
          DownloadUtil.saveURLs(blob, fileName);
        }
      } catch (error) {
        console.error(error);
        throw error;
      }
    },

    openDeleteModal(id) {
      this.selectedStaffId = id;
      this.$refs.DeleteModal.show();
    },
    closeDeleteModal() {
      this.$refs.DeleteModal.close();
    },
    openChangeClaimTypeModal() {
      this.$refs.ChangeClaimTypeModal.show();
    },
    closeChangeClaimTypeModal() {
      this.$refs.ChangeClaimTypeModal.close();
      this.selectedClaimType = null;
    },
    openDescriptionModal(ownerDescription, insurerDescription) {
      this.displayDescriptionOwner = ownerDescription;
      this.displayDescriptionInsurer = insurerDescription;
      this.$refs.DescriptionModal.show();
    },
    closeDescriptionModal() {
      this.$refs.DescriptionModal.close();
    },
  },
  async created() {
    if (!this.preview) {
      this.callFetch();
    }
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
@import "@/assets/scss/aisea/hull-insurance.scss";

#claim-type-form {
  font-family: $aisea-font-family;
  .action-button-area {
    display: flex;
    align-items: center;
    .trash-icon-button {
      background: white;
      border-radius: 6px;
      width: 34px;
      height: 34px;
      border: 1px solid $border-color1;
      display: flex;
      justify-content: center;
      color: $item-mono2;
      transition: 0.3s;
      cursor: pointer;
      &:hover {
        background: $hover-background-blue;
      }
    }
    .download-all-button {
      display: flex;
      align-items: center;
      border-radius: 6px;
      border: 1px solid $border-color1;
      height: 34px;
      padding: 10px;
      transition: 0.3s;
      cursor: pointer;
      &:hover {
        background: $hover-background-blue;
      }
    }
  }
}

.delete-container,
.change-claim-type-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  .button-area {
    display: flex;
    justify-content: space-between;
    width: 320px;
    margin-top: 20px;
    margin-bottom: 10px;
    .button {
      width: 140px;
    }
  }
}
</style>
